module.exports = __webpack_public_path__ + "static/media/sparePart.b00dc688.svg";